import _ from "lodash";

type RoleFilters = {
  contract: { length: number } & { [key: string]: any };
  orgUnit: any[];
  payOffice: any[];
  jobClassGroup: any[];
  workingPlace: any[];
  [key: string]: any;
};

type UseMyLeaveFilterListsParams = {
  filterType: string;
  filterTypeData: Array<{ code: string; name: string }>;
  roleFilters: RoleFilters;
  userRolesFilters: { [key: string]: string[] };
  search: string;
};

export const useMyLeaveFilterLists = ({
  filterType,
  filterTypeData,
  roleFilters,
  userRolesFilters,
  search,
}: UseMyLeaveFilterListsParams) => {
  let hasContract = roleFilters?.contract?.length > 0 ? true : false;
  let hasNoOtherFilter =
    roleFilters?.orgUnit.length === 0 &&
    roleFilters?.payOffice.length === 0 &&
    roleFilters?.jobClassGroup.length === 0 &&
    roleFilters?.workingPlace.length === 0;

  let selectedItems: Array<{ code: string; name: string }> = [];
  let availableItems: Array<{ code: string; name: string }> = [];
  let userRolesItems: Array<{ code: string; name: string }> = [];
  if (roleFilters && roleFilters[filterType]) {
    selectedItems = filterTypeData?.filter((item) =>
      roleFilters[filterType]?.includes(item.code),
    );
  }

  if (userRolesFilters && userRolesFilters[filterType]) {
    userRolesItems = filterTypeData?.filter((item) => {
      return userRolesFilters[filterType]?.includes(item.code);
    });
  }
  if (hasContract && hasNoOtherFilter && filterType !== "contract") {
    availableItems = [];
  } else if (!hasContract && !hasNoOtherFilter && filterType === "contract") {
    availableItems = [];
  } else {
    availableItems =
      userRolesItems?.length > 0
        ? _.difference(userRolesItems, selectedItems)
        : _.difference(filterTypeData, selectedItems);
  }

  let regex = new RegExp(search, "i");

  if (filterType === "orgUnit") {
    availableItems = _.filter(
      availableItems,
      (obj) => regex.test(obj.name) || regex.test(obj.code),
    );
  } else {
    availableItems = _.filter(availableItems, (obj) => regex.test(obj.name));
  }

  return {
    selectedItems,
    availableItems,
  };
};

export default useMyLeaveFilterLists;
